import { FC } from "react";
import { ShelvingItem } from "tm-shared/types";

import { PageBlock } from "@/shared/pageComposition/BlockList";
import { PrimaryText } from "@/shared/ui/Typography";

import {
    StyledAPRack,
    StyledAPRacksContainer,
    StyledAPShelf,
    StyledAPShelvesField,
    StyledAPShelvesHeader,
    StyledAPShelvesWrapper,
} from "../../Styled";
import { InfoTabShelvesCapabilities } from "./InfoTabShelves.policy";

export type InfoTabShelvesModel = {
    capabilities: InfoTabShelvesCapabilities;
    shelves: {
        shelvesLengthMeters: number;
        totalCm: number;
        racks: ShelvingItem[];
        isEmpty: boolean;
    };
};

interface RackCardProps {
    rack: ShelvingItem;
}

const RackCard: FC<RackCardProps> = ({ rack }) => (
    <StyledAPRack>
        <StyledAPShelvesField width="100%">{rack.name}</StyledAPShelvesField>
        <StyledAPShelvesWrapper>
            <PrimaryText fontSize={14} fontWeight="400">
                Полиці
            </PrimaryText>
            {rack.shelfs.map((shelf) => (
                <StyledAPShelf key={shelf.name}>
                    <StyledAPShelvesField width="62dvw">
                        {shelf.name}
                    </StyledAPShelvesField>
                    <StyledAPShelvesField width="100%">
                        {shelf.size}
                    </StyledAPShelvesField>
                </StyledAPShelf>
            ))}
        </StyledAPShelvesWrapper>
    </StyledAPRack>
);

const EmptyShelvesBlock: FC = () => (
    <PrimaryText fontSize={14} fontWeight="400" style={{ textAlign: "center" }}>
        Дані про конфігурацію полиць для даного маркету відсутні
    </PrimaryText>
);

const ShelvesSummaryBlock: FC<{
    shelvesLengthMeters: number;
    totalCm: number;
}> = ({ shelvesLengthMeters, totalCm }) => (
    <StyledAPShelvesHeader>
        <PrimaryText fontSize={14} fontWeight="400">
            Загальний поличний простір:
        </PrimaryText>
        <PrimaryText fontSize={14} fontWeight="400">
            {`${shelvesLengthMeters.toFixed(1)}м (${totalCm}см)`}
        </PrimaryText>
    </StyledAPShelvesHeader>
);

const ShelvesRacksBlock: FC<{ racks: ShelvingItem[] }> = ({ racks }) => (
    <StyledAPRacksContainer>
        {racks.map((rack) => (
            <RackCard key={rack.name} rack={rack} />
        ))}
    </StyledAPRacksContainer>
);

export const getInfoTabShelvesBlocks = (
    model: InfoTabShelvesModel,
): PageBlock<InfoTabShelvesModel>[] => [
    {
        key: "shelves-empty",
        order: 10,
        isVisible: (m) => m.capabilities.canSeeShelves && m.shelves.isEmpty,
        render: () => <EmptyShelvesBlock />,
    },
    {
        key: "shelves-summary",
        order: 10,
        isVisible: (m) => m.capabilities.canSeeShelves && !m.shelves.isEmpty,
        render: () => (
            <ShelvesSummaryBlock
                shelvesLengthMeters={model.shelves.shelvesLengthMeters}
                totalCm={model.shelves.totalCm}
            />
        ),
    },
    {
        key: "shelves-racks",
        order: 20,
        isVisible: (m) => m.capabilities.canSeeShelves && !m.shelves.isEmpty,
        render: () => <ShelvesRacksBlock racks={model.shelves.racks} />,
    },
];
